enum TipoUsuarioEnum {
  Hospital = 'hospital',
  Medico = 'medico',
  Secretaria = 'secretaria',
  SecretariaDoMedico = 'secretariaDoMedico',
  SecretariaDoAmbulatorio = 'secretariaDoAmbulatorio',
  SecretariaDoAgendamento = 'secretariaDoAgendamento',
  UsuarioBackoffice = 'usuarioBackoffice',
  UsuarioBackofficeCadastroMedicoRemuneracao = 'usuarioBackofficeCadastroMedicoRemuneracao',
}

export default TipoUsuarioEnum
